// TODO: Simplify event object...?
// TODO: { 'nameid': 'jim-allen', 'date': 'june 13, 2021' }
export const guestSpeakers = [
    {
        name: "Jim Allen",
        from: "North Jackson Street church of Christ<br />Houston, MS",
        date: "June 13, 2021",
        image: "https://www.cedarparkchurchofchrist.org/media/uploads/images/content/MenWeSupport/jim-allen.png",
    },
    {
        name: "Noah Diestelkamp",
        from: "Campbell Road church of Christ<br />Garland, TX",
        date: "July 11, 2021", // july 11
        image: "https://www.cedarparkchurchofchrist.org/media/uploads/public/gospel-meeting/spring-meeting-2021/noah-diestelkamp.jpg",
    },
    {
        name: "Wayne Welsh",
        from: "Hawk Ridge church of Christ<br />Duluth, MN",
        date: "November 7, 2021", // aug 1
        image: "https://www.cedarparkchurchofchrist.org/media/uploads/images/content/MenWeSupport/wayne-welsh.jpg",
    },
    {
        name: "Carlos Bello",
        from: "Talca, CHILE<br />(South America)",
        date: "May 15, 2022",
        image: "https://www.cedarparkchurchofchrist.org/media/uploads/images/content/MenWeSupport/carlos-bello.png",
    },
    {
        name: "Billy Kumar",
        from: "Preaching in India",
        date: "September 4, 2022",
        image: "https://www.cedarparkchurchofchrist.org/media/uploads/images/content/MenWeSupport/billy-kumar.png",
    },
];
